import { DualColor } from "../types";

export const utility = {
  divider: {
    light: "rgba(0,0,0,0.12)",
    dark: "rgba(255,255,255,0.12)",
  } as DualColor,

  hover: {
    light: "rgba(0,0,0,0.04)",
    dark: "rgba(255,255,255,0.08)",
  } as DualColor,
};
